import { Component, OnInit } from '@angular/core';
import { CommonUtilities } from 'src/assets/js/common-utilities';

@Component({
  selector: 'app-c-tradereference',
  templateUrl: './c-tradereference.component.html',
  styleUrls: ['./c-tradereference.component.css']
})
export class CTradereferenceComponent implements OnInit {
  outsideCompanyList:any[];
  WithinCompanyList:any[];
  displayBasic: boolean;
  _Status:any[]
  constructor(private utility:CommonUtilities) { }

  ngOnInit(): void {
    this.utility.pageLoadScript();
    this._Status = [
      {statuscode:'1',statusname:'Approve'},
      {statuscode:'2',statusname:'Reject'},
      {statuscode:'3',statusname:'Refer Back'},
      {statuscode:'4',statusname:'Hold'}
    ];
    this.WithinCompanyList = [
      {sno:'',name:'',designation:'',email:'',phno:'',previousexp:'',companycomment:''}
    ];
    this.outsideCompanyList = [
      {sno:'',name:'',designation:'',email:'',phno:'',previousexp:'',companycomment:''}
    ]
  }
  showBasicDialog(){
    this.displayBasic = true;
  }
}
